import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { AdminService } from 'src/app/admin-pages/admin.service';
import { ConfigService } from 'src/app/services/config.service';

@Component({
  selector: 'app-subscription-plans-list',
  templateUrl: './subscription-plans-list.component.html',
  styleUrls: ['./subscription-plans-list.component.scss']
})
export class SubscriptionPlansListComponent implements OnInit {

  @Output() IsPlanApplied = new EventEmitter<boolean>(); 
  subscriptionPlans: any[] = [];
  selectedPlan: any;
  contactNumber = "+91 9633 223355"
  isShowConfirmation: boolean = false;
  
  // for tost msg
  notificationMsg = ''
  showToast: boolean = false;
  isSuccess:boolean;

  loading: boolean = false;

  constructor(private adminService: AdminService,
    public configService: ConfigService) { }

  ngOnInit(): void {
    this.getSubscriptionPlans();
  }

  private notify(status: boolean, msg: string) {
    this.showToast = true;
    this.isSuccess = status;
    this.notificationMsg = msg;
    setTimeout(() => {
      this.showToast = false;
    }, 3000);
  }

  public onClickPlan(item: any) {
    this.selectedPlan = item;
    this.isShowConfirmation = true;
  }


  private processPlans() {
    this.subscriptionPlans.map((item: any) => {
      let subscriptionDetails = JSON.parse(item.Details ?? "{}");
      item.OrderCount = subscriptionDetails?.OrderCount ?? 0;
      item.ProductCount = subscriptionDetails?.ProductCount ?? 0;
      item.CustomerCount = subscriptionDetails?.CustomerCount ?? 0;
      item.planDetails = subscriptionDetails?.Description.split("#") ?? [];
    }) 

  }

  public copyToClipBoard() {
    this.configService.copyToClipBoard(this.contactNumber);
    this.notify(true, "Copied to clip board")
  }

  // API CALLS
  private getSubscriptionPlans() { 
    this.loading = true;
    this.adminService.getSubscriptionPlans().subscribe((res: any) => {
      this.loading = false;
      if (res?.Result == "Success" && res?.ResponseData) {
        this.subscriptionPlans = res.ResponseData;
        this.selectedPlan =  this.configService.currentPlanDetails.value;
        this.processPlans()
      }
    }, (err: HttpErrorResponse) => {
      this.loading = false;
    })
  }

}
